export const styles ={ 
  sliderStyle: {  
  position: 'relative',
  width: '60%',
  height: 80,
  alignSelf:'center'
},

railStyle:{
  position: 'absolute',
  width: '100%',
  height: 10,
  marginTop: 35,
  borderRadius: 5,
  backgroundColor: '#8B9CB6',
},
};

